import React from "react";
import styled from "styled-components";

const StyledSvg = styled.svg`
  pointer-events: auto;
  display: flex;
`;

const LightningIcon = () => {
  return (
    <StyledSvg
      width="24"
      height="24"
      viewBox="0 -960 960 960"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <path d="m422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z" />
    </StyledSvg>
  );
};

export default LightningIcon;
